export const regexpPhone = (phoneNumber) => {
  const pattern = /^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/
  const formattedNumber = phoneNumber.replace(pattern, '$1 ($2) $3-$4-$5')

  return `+${formattedNumber}`
}
